"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAuthor = formatAuthor;

function formatAuthor(author) {
  if (!author) {
    return '';
  }

  var firstName = author.firstName,
      lastName = author.lastName,
      email = author.email;

  if (firstName && lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }

  if (email) {
    return email;
  }

  return '';
}